.sn-deadlines-type-3 {
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($spacings, 2xl);

    @include above($breakpoint-desktop-md) {
      margin-bottom: map-get($spacings, 3xl);

      .me-text {
        max-width: calc(100% * 8 / 12);
      }
    }
  }

  &__list {
    display: flex;
    flex-direction: column;

    @include above($breakpoint-desktop-md) {
      max-width: 1000px;
    }
  }

  &__item {
    display: flex;
    gap: map-get($spacings, lg);
    align-items: flex-start;
  }

  &__indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
  }

  &__icon-box {
    display: flex;
    align-items: center;
    justify-content: center;

    @include size(32px);

    background-color: var(--color-brand-primary-lightest); // TODO: no exact token (was #e0ecfd)
    flex-shrink: 0;
  }

  &__icon {
    color: var(--color-brand-primary-main); // TODO: no exact token (was #0B5DE3)
  }

  &__connector {
    width: 0;
    border-left: 2px dashed var(--border-color-secondary); // TODO: no exact token (was #c4c4c4)
    min-height: map-get($spacings, lg);
    margin-top: map-get($spacings, sm);
    margin-bottom: map-get($spacings, sm);
    flex: 1;
  }

  &__content {
    padding-bottom: map-get($spacings, xl);

    @include above($breakpoint-desktop) {
      padding-bottom: map-get($spacings, 2xl);
    }

    strong {
      font-weight: 700;
    }
  }

  // Date lead-in rendered as <me-heading tag="h4"> for SEO, kept inline with
  // the following text and matching the sibling body sizing/weight.
  &__date {
    display: inline;
    font-weight: 700;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }

    h4,
    .me-heading {
      display: inline;
      font: inherit;
      color: inherit;
      margin: 0;
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
